











import Vue from 'vue';

export default Vue.extend({
  props: {
    routeName: {
      type: String,
      required: false
    }
  }
});
